import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.173444 1.7075C1.82916 3.65 4.88651 7.25 4.88651 7.25V11.75C4.88651 12.1625 5.25536 12.5 5.70617 12.5H7.3455C7.79632 12.5 8.16516 12.1625 8.16516 11.75V7.25C8.16516 7.25 11.2143 3.65 12.87 1.7075C13.2881 1.2125 12.9028 0.5 12.2225 0.5H0.820978C0.140657 0.5 -0.244584 1.2125 0.173444 1.7075Z",
		fill: "currentColor"
	})
});
export default SvgFilter;
